// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608281234/js/" + chunkId + "." + {"44":"8378abf4","225":"6ec566c6","481":"14515871","486":"0d02fc48","770":"409c29af"}[chunkId] + ".0.7237561312218929.chunk.js";
};